import { render, staticRenderFns } from "./zhScore.vue?vue&type=template&id=1765fe58&scoped=true"
import script from "./zhScore.vue?vue&type=script&lang=js"
export * from "./zhScore.vue?vue&type=script&lang=js"
import style0 from "./zhScore.vue?vue&type=style&index=0&id=1765fe58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1765fe58",
  null
  
)

export default component.exports